import { AlertErrorAlert } from "components/Alerts/AlertErrorAlert";
import environment from "constants/apiConst";
import { useContext, useState, useEffect, useCallback, useMemo } from "react";

import { useSelector } from "react-redux";
import {
  __SearchPOST,
  __SearchUser
} from "request/Reviews/__GetTReviews";
import { HeaderSearch } from "styled/SectionContainer.styled";
import ReviewsHeader from "../TableReviews/ReviewsHeader";
import TableOrder from "components/Tables/TableOrder";
import Pagination from "components/Pagination/Pagination";
import TbodyUpdateReview from "./TbodyUpdateReview";
import { theadUpdateReview } from "../TableReviews/thead/thead";
import { CardUpdateReview } from "../Cards/CardUpdateReview/CardUpdateReview.jsx";
import { DivGrid } from "../Styles/Styled";
import { SearchModule } from "components/SearchSimpleAdvanced/SearchAdvancedModule";
import { Storage } from "hooks/useStorage";
import FormCrudCRUDContext from "context/FormCrudContex";

import { Box, FormControl } from "@chakra-ui/react";
import { InputSelectMulti } from "components/InputSelect/InputSelect";
import { __GetAll } from "request/configuration/__QualifiedUsers";
import { useQuery } from "@tanstack/react-query";
import { useGlobalContext } from "context/GlobalContext";

export const UpdateReview = () => {
  const { flagUpdateReviews } =
    useContext(FormCrudCRUDContext);
  const { user_rol, admin, freeZone_id } = useSelector((state) => state.auth.dataUser);
  // eslint-disable-next-line no-unused-vars
  const [allAccess, setAllAccess] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const token = useSelector((state) => state.auth.dataUser.token);

  const { get, set } = Storage;

  const [openAlert] = AlertErrorAlert();
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  // Local loading removed; we rely on query's loading state
  const [resData, setResData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [recient, setRecient] = useState("");
  const [card, setCatd] = useState([]);

  const [freeTradeZone, setFreeTradeZone] = useState([]);
  const [usersReviewer, setUsersReviewer] = useState([]);

  // Deriva filtros memoizados para evitar renders innecesarios
  const newReviewer = useMemo(() => {
    const reviewers = [];
    if (usersReviewer) {
      usersReviewer.forEach(({ value }) => reviewers.push(value));
    }
    return reviewers;
  }, [usersReviewer]);

  const SearchReviewer = useMemo(() => ({
    reviewer: newReviewer
  }), [newReviewer]);

  const SearchZone = useMemo(() => ({
    freeZone: freeTradeZone?.value
  }), [freeTradeZone]);

  // Define SearchUserCard antes de los efectos que lo usan
  const SearchUserCard = useCallback(async (data) => {
    try {
      const res = await __SearchUser(environment.GET_USERS_REVIEW, token, data);
      const status = res?.data?.status;
      if (status.code !== 200) {
        setResData([]);
        openAlert(status?.message, "error");
      } else {
        setCatd(res?.data?.status?.data);
      }
    } catch (error) {
      // noop
    }
  }, [token, openAlert]);

  useEffect(() => {
    // Actualiza las tarjetas de usuarios según filtros
    SearchUserCard(SearchReviewer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [freeTradeZone, usersReviewer, flagUpdateReviews, freeZone_id, SearchReviewer, SearchUserCard]);

  // Query para tabla principal basada en patrón de Form-tables-entry
  const { requestData } = useGlobalContext();
  const { data: dataReviews, isLoading: isLoadingReviews } = useQuery({
    queryKey: ["REVIEW_UPDATE_QUEUE", freeZone_id, page, JSON.stringify(usersReviewer), JSON.stringify(freeTradeZone)],
    queryFn: () => requestData({
      Endpoint: environment.GET_REVIEW_UPDATE,
      PropertyBody: "POST",
      data: { ...SearchZone, ...SearchReviewer },
      pageParam: page
    }),
    keepPreviousData: true,
    refetchOnWindowFocus: false
  });

  // (definido arriba)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    GetUserCard();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_rol, allAccess, admin, freeZone_id]);

  // Filtros derivados (memoizados arriba)

  // Sincroniza datos de tabla cuando cambia la respuesta de la consulta
  useEffect(() => {
    if (!dataReviews) return;
    const status = dataReviews?.data?.status;
    if (status?.code !== 200) {
      setResData([]);
      openAlert(status?.message, "error");
      return;
    }
    setResData(status?.data?.data || []);
    setRecient(Array.isArray(status?.data?.data) ? status?.data?.data?.length : 0);
    setMaxPage(status?.data?.last_page || 1);
  }, [dataReviews, openAlert]);

  const GetUserCard = async () => {
    try {
      // Corrige el orden de parámetros: body y luego page
      const res = await __SearchPOST(environment.GET_USERS_REVIEW, token, "", page);
      const status = res?.data?.status;
      if (status.code !== 200) {
        setResData([]);
        openAlert(status?.message, "error");
      } else {
        setCatd(res?.data?.status?.data);
      }
    } catch (error) {
    }
  };

  const [revisor, setRevisores] = useState([]);

  const getUserData = useCallback(async () => {
    try {
      const res = await __GetAll(
        environment.GET_USERS_REVIEWER_NOT_PAGE,
        token
      );

      if (res?.data?.status?.data) {
        const infoZf = res.data.status.data.map((item) => ({
          label: item.nickname,
          value: item?.id
        }));
        setRevisores(infoZf);
      }
    } catch (error) {
      console.error(error);
    }
  }, [token]);

  useEffect(() => {
    // get("zfReviwer")
    const dataZf = get("ZfReviwer");

    if (dataZf) {
      setFreeTradeZone(dataZf);
    }
    const dataReviewr = get("Reviwer");
    if (dataReviewr.length > 0) {
      setUsersReviewer(dataReviewr);
    }
    getUserData();
  }, [get, getUserData]);

  const handleChangeZf = (item) => {
    set("ZfReviwer", item);
    setFreeTradeZone(item);
  };
  const handleChangeRevi = (item) => {
    set("Reviwer", item);
    setUsersReviewer(item);
  };

  return (
    <>
      <Box
        display={"flex"}
        gridGap={6}
        shadow={
          "rgb(50 50 93 / 25%) 0px 2px 5px -1px, rgb(0 0 0 / 30%) 0px 1px 3px -1px;margin: 0.5rem 0.5rem"
        }
        m={"0.5rem 0.5rem"}
        p={"1rem"}
        borderRadius=" 5px"
        w="full"
      >
        <FormControl display="none">
          <SearchModule
            tag={"Zonas Francas"}
            type="FreeTradeZone"
            service={environment.GET_ZONAS_F_NOT_PAGE}
            setValueQuialified={handleChangeZf}
            valueQualified={freeTradeZone}
          />
        </FormControl>

        <FormControl>
          <div style={{ width: "100%" }}>
            <InputSelectMulti
              tag={"Revisores"}
              data={revisor}
              set={handleChangeRevi}
              value={usersReviewer}
            />
          </div>
        </FormControl>
      </Box>

      <DivGrid Size="260px">
        {card.map((x, index) => {
          return <CardUpdateReview key={index} data={x} />;
        })}
      </DivGrid>

      <HeaderSearch>
        <ReviewsHeader title={"Todos los documentos"} mt="mt-5" />

        <TableOrder
          thead={theadUpdateReview}
          data={resData}
          isNum={false}
          setData={setResData}
          loading={isLoadingReviews}
          tbodyData={TbodyUpdateReview}
        />
        <Pagination
          thead={theadUpdateReview}
          page={page}
          setPage={setPage}
          maxPage={maxPage}
          loading={isLoadingReviews}
        />
      </HeaderSearch>
    </>
  );
};
